/* Copyright 2017 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace dvs_ui {

   export class DvsUpgradeNiocWizardPages {

      public static $inject = [
            "i18nService",
            "dvsUpgradeNiocWizardConstants",
            "simpleValidationCommit",
            "dvsPrerequisitesPageValidator",
            "vuiConstants"
      ];

      constructor(private i18nService: any,
                  private wizardConstants: any,
                  private simpleValidationCommit: any,
                  private dvsPrerequisitesPageValidator: any,
                  private vuiConstants: any) {
      }

      /**
       * Creates an array of page definitions for the Upgrade NIOC wizard.
       */
      public createPages(wizardScope: DvsUpgradeNiocWizardScope): WizardPage[] {

         let overviewPage: WizardPage = {
            id: this.wizardConstants.pages.DVS_NIOC_OVERVIEW_PAGE,
            title: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.overview.title"),
            description: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.overview.description"),
            contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                  "dvsUpgradeNiocOverviewPage.html",
            onCommit: this.simpleValidationCommit(function () {
               return [];
            }, wizardScope.wizardConfig),
            validationParams: []
         };

         let prerequisitesPage: WizardPage = {
            id: this.wizardConstants.pages.DVS_NIOC_VALIDATION_PAGE,
            title: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.prerequisites.title"),
            description: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.prerequisites.description"),
            contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                  "dvsUpgradeNiocPrerequisitesPage.html",
            onCommit: this.simpleValidationCommit(() => {
               return this.dvsPrerequisitesPageValidator.getValidationResult(
                     wizardScope.model.prerequisiteChecks,
                     wizardScope.model);
            }, wizardScope.wizardConfig),
            validationParams: []
         };

         let migrateSharesPage: WizardPage = {
            id: this.wizardConstants.pages.DVS_NIOC_MIGRATE_SHARES_PAGE,
            title: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.migrateShares.title"),
            description: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.migrateShares.description"),
            contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                  "dvsUpgradeNiocSharesPage.html",
            onCommit: this.simpleValidationCommit(() => {
               return [];
            }, wizardScope.wizardConfig),
            validationParams: ["model.migrateShares"]
         };

         let summaryPage: WizardPage = {
            id: this.wizardConstants.pages.DVS_NIOC_SUMMARY_PAGE,
            title: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.summary.title"),
            description: this.i18nService.getString("DvsUi",
                  "DvsUpgradeNiocWizard.summary.description"),
            contentUrl: "dvs-ui/resources/dvs/niocupgrade/views/" +
                  "dvsUpgradeNiocSummaryPage.html",
            onCommit: this.simpleValidationCommit(function () {
               return [];
            }, wizardScope.wizardConfig),
            validationParams: []
         };

         let pages: WizardPage[] = [
               overviewPage,
               prerequisitesPage,
               migrateSharesPage,
               summaryPage
         ];

         return pages;
      }

      public skipPage(pages: WizardPage[], pageToSkipId: string): void {
         let page: WizardPage = _.findWhere(pages, { id: pageToSkipId });
         if (page) {
            page.state = this.vuiConstants.wizard.pageState.SKIPPED;
         }
      }
   }

   angular.module("com.vmware.vsphere.client.dvs")
         .service("dvsUpgradeNiocWizardPages", DvsUpgradeNiocWizardPages);
}
